<template>
    <div class="workshops_cycle_2">
        <HeaderSivoaVue />

        <div class="workshops_container" v-if="!registering_done">
            <router-link to="/">
                <img src="./images/WorkshopsCycle2/accueil.svg" alt="classe" height="20px" width="68px" />
            </router-link>
            <div class="workshops_title0">DEMANDE D'INSCRIPTION AUX <span id="workshops_blue_text">ATELIERS CYCLE 2</span></div>
            <div class="workshops_title0">DU SYNDICAT DE L'ORGE</div>

            <div class="w3-cell-row w3-mobile">
				<img src="./images/WorkshopsCycle2/attention.svg" alt="attention" height="16px" width="16px"/>
				<span class="workshops_send_registration_warning">&nbsp; 2 classes de cycle 2 maximum par école</span>
            </div>
            <div style="height: 20px;"></div>

            <div class="w3-row-padding w3-stretch">
                <div class="w3-row">
                    <div class="w3-container w3-round-xlarge" style="background-color: #0A71B3; padding-top: 16px;">
                        <div class="w3-row">
                            <div class="w3-container w3-half w3-mobile">
                                <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white;">
                                    INFORMATIONS SUR L'&Eacute;COLE
                                </div>
                                <div class="w3-row">
                                    <select required id="school_city" v-on:change="selectCity()" v-model="school_city" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font">
                                        <option value="" disabled selected>Sélectionnez la ville de l'école *</option>
                                        <option v-for="item in city_list" v-bind:key="item.id" v-bind:value="item.city_name">{{ item.city_name }}</option>
                                    </select>
                                </div>
                                <div class="w3-row">&nbsp;</div>
                                <div class="w3-row">&nbsp;</div>

                                <div v-if="school_quota !== -1">
                                    <div style="display: flex; float: left; margin-bottom: 10px;" >
                                        <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white; line-height: 20px; display: table; margin-right: 5px;">
                                            Classe(s) de Cycle 2 déjà inscrite(s)
                                        </div>
                                        <div style="background-color: white; color: #0A71B3; text-align: center; width: 20px; display: inline flow;">{{ school_quota }}</div>
                                    </div>
                                    <div style="display: flex; float: right;" >
                                        <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white; line-height: 20px; display: table; margin-right: 5px;">
                                            Place(s) disponible(s)
                                        </div>
                                        <div style="background-color: white; color: #0A71B3; text-align: center; width: 20px; display: inline flow;">{{ 2 - school_quota }}</div>
                                    </div>
                                </div>
                                
                                <div class="w3-row">
                                    <select required id="school_name_id" v-on:change="selectSchool()" v-model="school_name_id" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font">
                                        <option value="-1" disabled selected>Sélectionnez le nom de l'école *</option>
                                        <option v-for="item in school_list" v-bind:key="item.id" v-bind:value="item.id">{{ item.school_name }} ({{ item.school_city }})</option>
                                    </select>
                                </div>
                                <div class="w3-row">
                                    <input id="school_address" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font" v-model="school_address" :readonly="true" placeholder="Adresse de l'école *">
                                </div>
                                <div class="w3-row">
                                    <input id="school_phone" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font" v-model="school_phone" :readonly="true" placeholder="Téléphone de l'école *">
                                </div>
                            </div>

                            <div class="w3-container w3-half w3-mobile">
                                <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white;">
                                    INFORMATIONS SUR LA CLASSE
                                </div>
                                <div class="w3-row">
                                    <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                        <input id="school_class" class="w3-input w3-block w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font" v-model="school_class" placeholder="CP/CE1/CE2 *">
                                    </div>
                                    <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                        <select required id="school_pupils_nb" v-model="school_pupils_nb" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font">
                                            <option value="-1" disabled selected>Nombre d'élèves *</option>
                                            <option v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                                            22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35]" v-bind:key="i" v-bind:value="i">{{ i }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-weight: thin; font-size: 11px; color: white;">
                                    Si classe dédoublée : Prévoir de regrouper 2 classes pour les interventions donc ne remplir qu'une seule inscription pour les 2 classes.
                                </div>
                                <div class="w3-row">&nbsp;</div>
                                <div class="w3-row" style="font-family: 'Roboto', sans-serif; font-size: 12px; color: white;">
                                    INFORMATIONS SUR L'ENSEIGNANT
                                </div>
                                <div class="w3-row">
                                    <input type="radio" id="workshops_radio_button_civility_mme" value="Mme" style="margin-left:0px;" v-model="civility_check">
                                    <label for="workshops_radio_button_civility_mme" class="workshops_radio_button workshops_textbox_font" style="margin-left: 5px; color: white;">Mme</label>
                                    &nbsp;&nbsp;
                                    <input type="radio" id="workshops_radio_button_civility_m" value="M." v-model="civility_check">
                                    <label for="workshops_radio_button_civility_m" class="workshops_radio_button workshops_textbox_font" style="margin-left: 5px; color: white;">M.</label>
                                </div>
                                <div class="w3-row">
                                    <input id="school_teacher" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font" v-model="school_teacher" placeholder="Nom de l'enseignant *">
                                </div>
                                <div class="w3-row">
                                    <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                        <input id="school_teacher_email" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font" v-model="school_teacher_email" placeholder="Mail de l'enseignant *">
                                    </div>
                                    <div class="w3-container w3-half w3-mobile" style="padding: 2px;">
                                        <input id="school_teacher_mobile" class="w3-input w3-border-0 w3-round-medium w3-margin-bottom workshops_textbox_font" v-model="school_teacher_mobile" placeholder="N° de portable de l'enseignant *">
                                    </div>
                                </div>
                            </div>
                        </div>
						
                        <div class="w3-row">
                            <div class="w3-container w3-mobile w3-right">
                                <div class="mandatory_info_text">* Champs obligatoires</div>
                            </div>
                        </div>
                        <div class="w3-row">&nbsp;</div>
                    </div>
                </div>
                <br>
                <div class="w3-row">
                    <div id="workshops_title1">ATELIERS <span style="font-size: 16px">(CP - CE1 - CE2)</span></div>

                    <div class="w3-row">
                        <div class="w3-left">
                            <div id="workshops_title2" style="float: left; color: #0A71B3;">Choisissez au <strong>maximum 2 ateliers</strong> : </div>
                        </div>
                        <div class="w3-left">
                            <div id="workshops_title2" style="float: left; margin-right: 5px;">&nbsp;Atelier(s) choisi(s)</div>
                            <div style="float: left; border: 1px solid; background-color: white; color: #0A71B3; text-align: center; line-height: 16px; height: 20px; width: 20px;">{{ workshops_to_attend.length }}</div>
                        </div>
                        <div class="w3-left">
                            <div id="workshops_title2" style="float: left; margin-right: 5px; margin-left: 20px;">Atelier(s) disponible(s)</div>
                            <div style="float: left; border: 1px solid; background-color: white; color: #0A71B3; text-align: center; line-height: 16px; height: 20px; width: 20px;">{{ 2 - workshops_to_attend.length }}</div>
                        </div>
                    </div>
                </div>
                    
                <div style="height: 10px;"></div>

                <div class="w3-row" style="border: 3px solid #0A71B3; border-radius: 10px; padding: 10px;">
					<div class="w3-container w3-half w3-mobile">
						<div class="workshops_title3" style="margin-bottom: 10px;">
							<img src="./images/WorkshopsCycle2/classe.svg" alt="classe" height="28px" width="28px" />
							<div style="padding-left: 5px;">En classe - 1h30</div>
						</div>
						<div v-for="item of workshops_in_class_list" v-bind:key="item.id">
                            <div class="w3-row popup">
                                <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                    <label class="container">
                                        <input type="checkbox" :disabled="!workshops_to_attend.includes(item.description) && workshops_to_attend.length >= 2" v-bind:value="item.description" v-model="workshops_to_attend">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>

                                <div class="w3-rest" v-on:mouseover="displayPopup(`popup${item.id}`)" v-on:mouseout="closePopup(`popup${item.id}`)" >
                                    <span v-if="!workshops_to_attend.includes(item.description) && workshops_to_attend.length >= 2" class="workshops_checkbox_disabled" style="display: inline-block; width: 90%;">{{ item.description }}</span>
                                    <span v-else-if="workshops_to_attend.includes(item.description)" class="workshops_checkbox_selected" style="display: inline-block; width: 90%;">{{ item.description }}</span>
                                    <span v-else class="workshops_checkbox" style="display: inline-block; width: 90%;">{{ item.description }}</span>

                                    <div class="popuptext" v-bind:id="`popup${item.id}`">
                                        <span><b><u>{{ item.titre }}</u></b></span><br>
                                        <span v-for="obj of item.objectifs" v-bind:key="obj">- {{ obj }} <br></span>
                                        <span><b>Lieu</b>: {{ item.lieu }}</span>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>

					<div class="w3-container w3-half w3-mobile">
						<div class="workshops_title3" style="margin-bottom: 10px;">
							<img src="./images/WorkshopsCycle2/terrain.svg" alt="terrain" height="28px" width="28px" />
							<div style="padding-left: 5px;">Sur le terrain - 2h</div>
						</div>
						<div v-for="item of workshops_on_field_list" v-bind:key="item.id">

                            <div style="margin-left: 30px; margin-bottom: 10px;">
                                <div style="display: flex; align-items: top;">
                                    <img src="./images/WorkshopsCycle2/attention.svg" alt="attention" height="32px" width="32px" style="margin-right: 10px;" />
                                    <span style="font-family: Arial; font-size: 16px; color: rgb(237, 28, 36);">
                                        Cet atelier sur le terrain se déroule sur un site du Syndicat de l'Orge. Prévoir un moyen de transport pour y accéder si l'école est éloignée du site.
                                    </span>
                                </div>
                                <div onclick="window.open('https://sivoa91.maps.arcgis.com/apps/View/index.html?appid=dab2e36734d747178df45e46b65b9631', '_blank');" style="display: flex; align-items: center; cursor: pointer;">
                                    <img src="./images/WorkshopsCycle2/carte.svg" alt="appli_carte" height="30px" width="30px" style="margin-right: 10px;" />
                                    <div style="font-family: Arial; font-size: 16px; color: rgb(112, 74, 56);">
                                        <div>Simulez votre itinéraire</div>
                                    </div>
                                </div>
                            </div>

                            <div class="w3-row popup">
                                <div class="w3-col" style="margin: 5px; height: 30px; width: 30px; float: left;">
                                    <label class="container">
                                        <input type="checkbox" :disabled="!workshops_to_attend.includes(item.description) && workshops_to_attend.length >= 2" v-bind:value="item.description" v-model="workshops_to_attend">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>

                                <div class="w3-rest" v-on:mouseover="displayPopup(`popup${item.id}`)" v-on:mouseout="closePopup(`popup${item.id}`)" >
                                    <span v-if="!workshops_to_attend.includes(item.description) && workshops_to_attend.length >= 2" class="workshops_checkbox_disabled" style="display: inline-block; width: 90%;">{{ item.description }}</span>
                                    <span v-else-if="workshops_to_attend.includes(item.description)" class="workshops_checkbox_selected" style="display: inline-block; width: 90%;">{{ item.description }}</span>
                                    <span v-else class="workshops_checkbox" style="display: inline-block; width: 90%;">{{ item.description }}</span>

                                    <div class="popuptext" v-bind:id="`popup${item.id}`">
                                        <span><b><u>{{ item.titre }}</u></b></span><br>
                                        <span v-for="obj of item.objectifs" v-bind:key="obj">- {{ obj }} <br></span>
                                        <span><b>Lieu</b>: {{ item.lieu }}</span>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
                </div>
            </div>

            <div class="w3-row workshops_more_info">
                <div id="workshops_title4">Souhaitez-vous apporter des précisions ?*</div>
                <div class="mandatory_info_text2">* Champ obligatoire</div>
                <div class="w3-row-cell">
                    <div class="w3-cell">
                        <input type="radio" id="workshops_radio_button_details_yes" value="1" v-model="details_check">
                        <label for="workshops_radio_button_details_yes" class="workshops_radio_button" style="margin-left: 10px;">Oui</label>
                    </div>
                    <div class="w3-cell">
                        <input type="radio" id="workshops_radio_button_details_no" value="0" v-model="details_check" style="margin-left: 16px;">
                        <label for="workshops_radio_button_details_no" class="workshops_radio_button" style="margin-left: 10px;">Non</label>
                    </div>
                </div>
                <textarea class="workshops_more_info_textbox" v-if="details_check==1" v-model="details_text" placeholder="Précisez lesquelles... [4500 caractères]"></textarea>
            </div>
            <div style="height: 20px;"></div>

            <div class="w3-panel w3-red w3-center workshops_alert" v-if="IsSendingButtonWarningTextDisplayed">
                <p>{{ SendingButtonWarningText }}</p>
            </div>

            <div class="w3-panel w3-red w3-center modules_alert" v-if="sending_error">
                <p>UNE ERREUR S'EST PRODUITE LORS DE L'ENVOI DU FORMULAIRE D'INSCRIPTION</p>
                <p>VOTRE INSCRIPTION N'A PAS &Eacute;T&Eacute; PRISE EN COMPTE</p>
                <p>VEUILLEZ CLIQUER &Agrave; NOUVEAU SUR LE BOUTON "ENVOYER L'INSCRIPTION"</p>
                <p>SI LE PROBLEME PERSISTE VOUS POUVEZ PRENDRE CONTACT AVEC LE SYNDICAT DE L'ORGE</p>
            </div>

            <div class="w3-row w3-mobile w3-center">
                <div class="w3-col">
                    <div v-if="IsSendingButtonDisabled">Une fois ce formulaire envoyé, vous recevrez un mail avec le récapitulatif de votre demande.</div>
                    <br>
                    <button class="w3-center w3-btn w3-mobile w3-round-large w3-xlarge w3-ripple workshops_send_button" v-bind:disabled="IsSendingButtonDisabled"  v-on:click="submitWithCaptcha()">ENVOYER L'INSCRIPTION</button>
                    <div v-if="!IsSendingButtonDisabled">
                        <br>
                        <div>Veuillez vérifier votre boîte de réception e-mail (et si besoin votre boîte SPAM).</div>
                        <div><strong>Si vous ne recevez pas le mail de confirmation, veuillez nous contacter.</strong></div>
                    </div>
                </div>
            </div>

            <div style="height: 50px;"></div>
            <div class="w3-row w3-mobile">
                <div class="w3-center">
                    <img src="./images/WorkshopsCycle2/attention.svg" alt="attention" height="32px" width="32px" />
                </div>
                <div class="w3-center">
                    <span class="workshops_send_registration_warning">VOTRE INSCRIPTION N'EST PAS D&Eacute;FINITIVE, CHAQUE FORMULAIRE EST SOUMIS &Agrave; VALIDATION.</span>
                </div>
            </div>
            <div class="w3-row w3-center w3-mobile workshops_last_infos">
                Si votre demande est s&eacute;lectionn&eacute;e, nous vous contacterons <strong>au cours de l'ann&eacute;e</strong> environ <strong>1 mois avant la date</strong> propos&eacute;e.
            </div>


            <!-- The Modal -->
            <div id="id01" class="w3-modal" style="display: block; opacity: 0.85; background-color: #0A71B3;" v-if="disable_sending_button">
                <div class="spinner circles">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="w3-center spinner_text">VOTRE FORMULAIRE EST EN COURS D'ENVOI</div>
            </div>
        </div>


        <div v-else class="w3-center">

            <div class="workshops_title0" style="margin-top: 64px;">Votre demande d’inscription a bien été prise en compte.</div>

            <div class="w3-section">
                <img src="./images/WorkshopsCycle2/attention.svg" alt="attention" height="32px" width="32px" />
                <span class="workshops_send_registration_warning">
                    VOTRE INSCRIPTION N'EST PAS D&Eacute;FINITIVE, CHAQUE FORMULAIRE EST SOUMIS &Agrave; UNE S&Eacute;LECTION.
                </span>
            </div>

            <span class="w3-section workshops_last_infos">
                Si votre demande est s&eacute;lectionn&eacute;e, nous vous contacterons <strong>au cours de l'ann&eacute;e</strong> environ <strong>1 mois avant la date</strong> propos&eacute;e.
            </span>

            <div class="w3-section">
                <router-link to="/">
                    <img src="./images/WorkshopsCycle2/accueil.svg" alt="classe" height="20px" width="68px" />
                </router-link>
            </div>
        </div>


        <div v-if="debug==1">
            <p>returned_data: {{ returned_data }} </p>
            <p>returned_status: {{ returned_status }} </p>
            <p>error_message: {{ error_message }} </p>
            <p>disable_sending_button: {{ disable_sending_button }} </p>
            <p>school_name: {{ school_name }} </p>
            <p>school_address: {{ school_address }} </p>
            <p>school_phone: {{ school_phone }} </p>
            <p>school_city: {{ school_city }} </p>
            <p>civility_check: {{ civility_check }} </p>
            <p>school_teacher: {{ school_teacher }} </p>
            <p>school_class: {{ school_class }} </p>
            <p>school_pupils_nb: {{ school_pupils_nb }} </p>
            <p>school_teacher_email: {{ school_teacher_email }} </p>
            <p>school_teacher_mobile: {{ school_teacher_mobile }} </p>
            <p>workshops_to_attend: {{ workshops_to_attend }} </p>
            <p>details_check: {{ details_check }} </p>
            <p>details_text: {{ details_text }} </p>
        </div>

        <vue-programmatic-invisible-google-recaptcha ref="invisibleRecaptcha1"
                                                     :sitekey="'6LelM7UUAAAAABrw5GqPXvDJby9bW37zMmlGahLq'"
                                                     :elementId="'invisibleRecaptcha1'"
                                                     :badgePosition="'left'"
                                                     :showBadgeMobile="false"
                                                     :showBadgeDesktop="false"
                                                     @recaptcha-callback="submit"></vue-programmatic-invisible-google-recaptcha>

        <FooterSivoaVue />
    </div>
</template>

<script>
    import HeaderSivoaVue from './HeaderSivoa.vue';
    import FooterSivoaVue from './FooterSivoa.vue';
    import axios from 'axios';

    export default {
        name: 'workshops_cycle_2_vue',
        data () {
            return {
                debug: 0,
                returned_data: '',
                returned_status: 0,
                error_message: '',
                quota_error: false,
                school_quota: -1,
                sending_error: false,
                registering_done: 0,
                disable_sending_button: false,
                school_name_id: -1,
                school_name: '',
                school_address: '',
                school_phone: '',
                school_city: '',
                school_teacher: '',
                school_class: '',
                school_pupils_nb: -1,
                school_teacher_email: '',
                school_teacher_mobile: '',
                workshops_to_attend: [],
                details_text: '',
                civility_check: '',
                details_check: -1,
                workshops_in_class_list: [
                    {
                        id: 0,
                        description: "L'eau indispensable à la vie",
                        titre: "L’eau indispensable à la vie",
                        objectifs: [
                            "Découvrir que tous les êtres vivants ont besoins d’eau pour vivre",
                            "Comprendre comment l’eau entre et sort de notre corps",
                            "Prendre conscience qu’il y a de l’eau dans tous les aliments",
                            "Se rendre compte que l’eau n’a pas toujours le même goût et comprendre pourquoi",
                        ],
                        lieu: "en classe",
                    },
                    {
                        id: 1,
                        description: "L'eau dans tous ses états",
                        titre: "Les états de l’eau",
                        objectifs: [
                            "Découvrir la méthode scientifique (hypothèse, expérience, conclusion)",
                            "Découvrir ou revoir les 3 états de l’eau",
                            "Comprendre comment l’eau change d’état",
                            "Prendre conscience des différents états de l’eau autour de soi et ailleurs sur la Terre",
                        ],
                        lieu: "en classe",
                    },
                    {
                        id: 2,
                        description: "Les pouvoirs de l'eau",
                        titre: "Les pouvoirs de l’eau",
                        objectifs: [
                            "Utiliser la méthode scientifique (hypothèse, expérience, conclusion)",
                            "Comprendre la poussée d’Archimède",
                            "Découvrir la tension superficielle de l’eau",
                            "Prendre conscience que tout ne se mélange pas dans l’eau",
                        ],
                        lieu: "en classe",
                    },
                ],
                workshops_on_field_list: [
                    {
                        id: 3,
                        description: "Balade sensorielle",
                        titre: "Balade sensorielle",
                        objectifs: [
                            "Découvrir le milieu naturel en utilisant ses sens",
                            "Développer sa créativité en pratiquant le land art",
                        ],
                        lieu: "sur un site du Syndicat",
                    },
                ],
                city_list: [
                    { id: 1, city_name: 'ANGERVILLIERS' },
                    { id: 2, city_name: 'ARPAJON' },
                    { id: 3, city_name: 'ATHIS-MONS' },
                    { id: 4, city_name: 'AUTHON-LA-PLAINE'},
                    { id: 5, city_name: 'AVRAINVILLE' },
                    { id: 6, city_name: 'BALLAINVILLIERS' },
                    { id: 7, city_name: 'BOISSY-LE-SEC' },
                    { id: 8, city_name: 'BOISSY-SOUS-SAINT-YON' },
                    { id: 9, city_name: 'BRETIGNY-SUR-ORGE' },
                    { id: 10, city_name: 'BREUILLET' },
                    { id: 11, city_name: 'BREUX-JOUY' },
                    { id: 12, city_name: 'BRIIS-SOUS-FORGES' },
                    { id: 13, city_name: 'BRUYERES-LE-CHATEL' },
                    { id: 14, city_name: 'CORBREUSE' },
                    { id: 15, city_name: 'COURSON-MONTELOUP' },
                    { id: 16, city_name: 'DOURDAN' },
                    { id: 17, city_name: 'EGLY' },
                    { id: 18, city_name: 'EPINAY-SUR-ORGE' },
                    { id: 19, city_name: 'FLEURY-MEROGIS' },
                    { id: 20, city_name: 'FONTENAY-LES-BRIIS' },
                    { id: 21, city_name: 'FORGES-LES-BAINS' },
                    { id: 22, city_name: 'GRIGNY' },
                    { id: 23, city_name: 'GUIBEVILLE' },
                    { id: 24, city_name: 'JANVRY' },
                    { id: 25, city_name: 'JUVISY-SUR-ORGE' },
                    { id: 26, city_name: 'LA NORVILLE' },
                    { id: 27, city_name: 'LA VILLE DU BOIS' },
                    { id: 28, city_name: 'LE PLESSIS-PATE' },
                    { id: 29, city_name: 'LE VAL-SAINT-GERMAIN' },
                    { id: 30, city_name: 'LES GRANGES-LE-ROI' },
                    { id: 31, city_name: 'LEUVILLE-SUR-ORGE' },
                    { id: 32, city_name: 'LIMOURS' },
                    { id: 33, city_name: 'LINAS' },
                    { id: 34, city_name: 'LONGPONT-SUR-ORGE' },
                    { id: 35, city_name: 'MARCOUSSIS' },
                    { id: 36, city_name: 'MAROLLES-EN-HUREPOIX' },
                    { id: 37, city_name: 'MONTLHERY' },
                    { id: 38, city_name: 'MORSANG-SUR-ORGE' },
                    { id: 39, city_name: 'NOZAY' },
                    { id: 40, city_name: 'OLLAINVILLE' },
                    { id: 41, city_name: 'PARAY-VIEILLE-POSTE' },
                    { id: 42, city_name: 'PECQUEUSE' },
                    { id: 43, city_name: 'RICHARVILLE' },
                    { id: 44, city_name: 'ROINVILLE' },
                    { id: 45, city_name: 'SAINT-CHERON' },
                    { id: 46, city_name: 'SAINT-CYR-SOUS-DOURDAN' },
                    { id: 47, city_name: 'SAINT-GERMAIN-LES-ARPAJON' },
                    { id: 48, city_name: 'SAINT-MAURICE-MONTCOURONNE' },
                    { id: 49, city_name: 'SAINT-MARTIN-DE-BRETHENCOURT' },
                    { id: 50, city_name: 'SAINT-MICHEL-SUR-ORGE' },
                    { id: 51, city_name: 'SAINT-YON' },
                    { id: 52, city_name: 'SAINTE-GENEVIEVE-DES-BOIS' },
                    { id: 53, city_name: 'SAINTE-MESME' },
                    { id: 54, city_name: 'SAVIGNY-SUR-ORGE' },
                    { id: 55, city_name: 'SERMAISE' },
                    { id: 56, city_name: 'SOUZY-LA-BRICHE' },
                    { id: 57, city_name: 'VAUGRIGNEUSE' },
                    { id: 58, city_name: 'VILLEMOISSON-SUR-ORGE' },
                    { id: 59, city_name: 'VILLIERS-SUR-ORGE' },
                    { id: 60, city_name: 'VIRY-CHATILLON' },
                ],
                school_list: [],
            }
        },
        mounted () {
        },
        created: function () {
            this.schoolList('');
        },
        methods: {
            bGotSchoolInfo: function() {
                return this.school_name.length > 0 &&
                    this.school_address.length > 0 &&
                    this.school_phone.length > 0 &&
                    this.school_city.length > 0 &&
                    this.school_teacher.length > 0 &&
                    this.school_class.length > 0 &&
                    this.school_pupils_nb > 0 &&
                    this.school_teacher_email.length > 0 &&
                    this.school_teacher_mobile.length > 0 &&
                    this.civility_check.length > 0;
            },
            bGotWorkshopsToAttend: function() {
                return this.workshops_to_attend.length > 0 && this.workshops_to_attend.length <= 2;
            },
            validateEmail(email) {
                if (!email) return true;
                return /\S+@\S+\.\S+/.test(email)
            },
            displayPopup(popup_name) {
                var popup = document.getElementById(popup_name);
                popup.style.visibility = 'visible';
            },
            closePopup(popup_name) {
                var popup = document.getElementById(popup_name);
                popup.style.visibility = 'hidden';
            },
            async schoolCount(city, school) {
                try {
                    var response = await axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/workshops_count.php',
                        data: {
                            city: city,
                            school: school,
                            cycle: 2,
                        },
                    });

                    var count = response.data.count;
                    return count;
                }
                catch (error) {
                    this.error_message = error;
                    this.sending_error = true;
                    return -1;
                }
            },
            schoolList(city) {
                axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/school_list.php',
                        data: {
                            type: 'ECOLE',
                            city: city,
                        },
                    })
                    .then((response) => {
                        this.school_list = response.data;   //id, type, school_name, school_address, school_city, school_phone
                        this.sending_error = false;
                    }).
                    catch((error) => {
                        this.error_message = error;
                        this.sending_error = true;
                    })
            },
            async selectSchool() {
                this.quota_error = false;

                var found = this.school_list.find(element => element.id == this.school_name_id);
                if (found) {
                    this.school_city = found.school_city;
                    this.school_name = found.school_name;
                    this.school_phone = found.school_phone;
                    this.school_address = found.school_address;

                    this.school_quota = await this.schoolCount(this.school_city, this.school_name);
                    if (!this.school_quota) this.school_quota = 0;
                    if (this.school_quota >= 2) this.quota_error = true;
                }
            },
            selectCity() {
                this.quota_error = false;

                this.school_name_id = -1;
                this.school_name = "";
                this.school_phone = "";
                this.school_address = "";
                this.school_quota = -1;
                this.schoolList (this.school_city);
            },
            submitWithCaptcha() {
                this.$refs.invisibleRecaptcha1.execute();
            },
            submit: async function (recaptchaToken) {
                var count = await this.schoolCount(this.school_city, this.school_name);
                if (count >= 2) {
                    this.quota_error = true;
                    return;
                }

                this.disable_sending_button = true;
                var w = '';
                for (let workshop of this.workshops_to_attend) {
                    w += workshop + "|";
                }

                var json_data = {
                    school_year: '2024',
                    cycle: 2,
                    school_name: this.school_name,
                    school_address: this.school_address,
                    school_city: this.school_city,
                    school_phone: this.school_phone,
                    school_teacher: this.civility_check + ' ' + this.school_teacher,
                    school_class: this.school_class,
                    school_pupils_nb: this.school_pupils_nb,
                    school_teacher_email: this.school_teacher_email,
                    school_teacher_mobile: this.school_teacher_mobile,
                    workshops_to_attend: w,
					details_text: this.details_text,
                    token: recaptchaToken,
                };

                this.sending_error = false;
                
                // Send email
                await axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/workshops_mail.php',
                        data: json_data,
                    })
                    .then((response) => {
                        console.log("Email sent status: " + response.status);
                    }).
                    catch((error) => {
                        this.error_message = error;
                        this.sending_error = true;
                    });

                if (!this.sending_error) await axios({
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        url: 'php/postdata_ws.php',
                        data: json_data,
                    })
                    .then((response) => {
                        this.returned_data = response.data;
                        this.returned_status = response.status;
                        this.sending_error = false;
                        this.registering_done = 1;
                    }).
                    catch((error) => {
                        this.error_message = error;
                        this.sending_error = true;
                    });

                this.disable_sending_button = false;
            },
        },
        components: {
            HeaderSivoaVue,
            FooterSivoaVue
        },
        computed: {
            IsSendingButtonDisabled: function () {
                var bButtonEnabled = !this.quota_error && this.bGotSchoolInfo() && this.bGotWorkshopsToAttend() && this.details_check != -1 && !this.disable_sending_button;
                return !bButtonEnabled;
            },
            SendingButtonWarningText: function () {
                if (this.quota_error) {
                    return "Déja 2 enseignants se sont inscrits dans cet établissement";
                }
                else if (!this.bGotSchoolInfo()) {
                    return "Veuillez sélectionner une école et saisir les informations de l'enseignant";
                }
                else if (this.workshops_to_attend.length == 0) {
                    return "Vous devez sélectionner au moins 1 atelier";
                }
                else if (this.workshops_to_attend.length > 2) {
                    return "Vous ne pouvez sélectionner que 2 ateliers maximum";
                }
                else if (!this.validateEmail(this.school_teacher_email)) {
                    return "Mauvais format de votre e-mail";
                }
                else if (this.details_check == -1) {
                    return "Veuillez renseigner si vous avez des précisions à apporter ou non";
                }
                else {
                    return "";
                }
            },
            IsSendingButtonWarningTextDisplayed: function () {
                if (this.quota_error) {
                    return 1;
                }
                else if (!this.bGotSchoolInfo()) {
                    return 1;
                }
                else if (!this.bGotWorkshopsToAttend()) {
                    return 1;
                }
                else if (!this.validateEmail(this.school_teacher_email)) {
                    return 1;
                }
                else if (this.details_check == -1) {
                    return 1;
                }
                else {
                    return 0;
                }
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        text-decoration: none;
    }

    select:required:invalid {
        color: #999999;
    }

    option[value=""][disabled] {
        display: none;
    }

    ::placeholder {
        color: #999999;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #999999;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
        color: #999999;
    }

    .workshops_cycle_2 {
        margin-left: 37px;
        margin-right: 37px;
    }

    .workshops_title0 {
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 32px;
        text-transform: uppercase;
        color: #6C382A;
        color: rgb(108, 56, 42);
        font-style: normal;
    }

    #workshops_blue_text {
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 32px;
        text-transform: uppercase;
        color: #0A71B3;
        color: rgb(10, 113, 179);
    }

    .workshops_textbox_font {
        font-family: Arial;
        font-size: 12px;
    }

    .mandatory_info_text {
        font-family: 'Roboto', sans-serif;
        font-size: 10px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }

    .mandatory_info_text2 {
        font-family: 'Roboto', sans-serif;
        font-size: 10px;
        color: #000000;
        color: rgb(0, 0, 0);
    }

    #external_workshop_only_text {
        font-family: 'Roboto', sans-serif;
        font-size: 12px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
        padding-bottom: 5px;
    }

    #workshops_title1 {
        font-family: 'Quicksand', sans-serif;
        font-weight: bold;
        font-size: 25px;
        color: rgb(10, 113, 179);
    }

    #workshops_title2 {
        font-family: Arial;
        font-size: 14px;
        color: #000000;
        color: rgb(0, 0, 0);
    }

    .workshops_title3 {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-family: 'Quicksand', sans-serif;
        font-weight: bold;
        font-size: 16px;
        color: #0A71B3;
        color: rgb(10, 113, 179);
        padding-bottom: 5px;
    }

    .workshops_checkbox {
        background: rgb(236, 248, 255);
        border-radius: 5px;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: rgb(10, 113, 179);
        padding: 5px;
        margin: 2px;
    }

    .workshops_checkbox_selected {
        background: rgb(10, 113, 179);
        border-radius: 5px;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: white;
        padding: 5px;
        margin: 2px;
    }

    .workshops_checkbox_disabled {
        background: rgba(230, 230, 230, 1);
        border-radius: 5px;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        font-family: Arial;
        font-weight: bold;
        font-size: 16px;
        color: rgb(120,120,120);
        padding: 5px;
        margin: 2px;
    }


    /* Popup container */
    .popup {
        position: relative;
        cursor: pointer;        
    }

    /* The actual popup (appears on top) */
    .popup .popuptext {
        visibility: hidden;
        background-color: rgb(10, 113, 179);
        opacity: .9;
        font-family: Arial;
        font-size: 14px;
        color: #fff;
        text-align: left;
        border-radius: 6px;
        padding: 5px;
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 1;
    }


    .check-with-label:checked + .label-for-check {
        color: #FFFFFF;
        background: #0A71B3;
    }

    #workshops_title4 {
        font-family: Arial;
        font-weight: bold;
        font-size: 14px;
        color: #0A71B3;
        color: rgb(10, 113, 179);
        padding-bottom: 5px;
    }

    .workshops_radio_button {
        font-family: Arial;
        font-size: 14px;
        color: rgb(0, 0, 0);
    }

    .workshops_more_info_textbox {
        border-style: Solid;
        border-color: #EBEBEB;
        border-color: rgba(235, 235, 235, 1);
        border-width: 1px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        -webkit-border-radius: 5px;
        font-family: Arial;
        font-size: 12px;
        color: #000000;
        width: 100%;
        resize: vertical;
        height: 120px;
    }

    .workshops_send_registration_warning {
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
        color: #ED1C24;
        color: rgb(237, 28, 36);
        text-align: justify;
        text-justify: inter-word;
        
    }

    .workshops_alert {
        font-family: Arial;
        font-size: 16px;
        text-transform: uppercase;
    }


    .workshops_send_button {
        font-family: 'Roboto Condensed', sans-serif;
        font-style: normal;
        color: #FFFFFF;
        outline: 0;
        background: #0A71B3;
    }
    .workshops_send_button:disabled {
        font-family: 'Roboto Condensed', sans-serif;
        font-style: normal;
        color: #FFFFFF;
        outline: 0;
        background: rgb(179,179,179);
    }

    .workshops_more_info {
        padding-top: 30px;
        padding-bottom: 30px;
    }

    .workshops_last_infos {
        font-family: Arial;
        font-size: 14px;
        color: #000000;
        color: rgb(0, 0, 0);
        text-align: justify;
        text-justify: inter-word;
        padding-bottom: 20px;
    }

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 2px;
  left: 2px;
  height: 25px;
  width: 25px;
  background-color: #ddd;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #0A71B3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
    top: 7px;
    left: 7px;
	width: 11px;
	height: 11px;
	border-radius: 50%;
	background: white;
}

input[type='radio'] {
    width: 18px;
    height: 18px;
    accent-color: #0A71B3;
    background-color: white;
    border: 1px solid #0A71B3;
    appearance: none; /* Enlever le style par défaut du navigateur */
    border-radius: 50%; /* Pour garder la forme circulaire */
    display: inline-block;
    position: relative;
    cursor: pointer;

    margin: 0; /* Supprime les marges par défaut */
    padding: 0; /* Supprime les padding par défaut */
    vertical-align: middle; /* Alignement vertical au milieu */
}

input[type='radio']:checked {
    background-color: white; /* Fond blanc lorsqu'il est sélectionné */
}

input[type='radio']:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60%;
    height: 60%;
    background-color: #0A71B3;
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

input[type='radio']:hover {
    background-color: white; /* Fond blanc au survol */
}
</style>